var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import { captureException } from 'services/posthog';
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { hasError: false };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function () {
        return { hasError: true };
    };
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        // Report to PostHog
        captureException(error, {
            componentStack: errorInfo.componentStack,
            errorBoundary: true
        });
        // Call custom error handler if provided
        var onError = this.props.onError;
        if (onError) {
            onError(error, errorInfo);
        }
        // Log to console in development
        if (process.env.NODE_ENV === 'development') {
            console.error('ErrorBoundary caught an error:', error, errorInfo);
        }
    };
    ErrorBoundary.prototype.render = function () {
        var hasError = this.state.hasError;
        var _a = this.props, fallback = _a.fallback, children = _a.children;
        if (hasError) {
            if (fallback) {
                return fallback;
            }
            return (_jsxs("div", { className: "error-boundary-fallback", style: {
                    padding: '20px',
                    textAlign: 'center',
                    color: '#721c24',
                    backgroundColor: '#f8d7da',
                    border: '1px solid #f5c6cb',
                    borderRadius: '4px',
                    margin: '20px'
                }, children: [_jsx("h2", { children: "Something went wrong" }), _jsx("p", { children: "We're sorry, but something unexpected happened. Please try refreshing the page." }), _jsx("button", { type: "button", onClick: function () { return window.location.reload(); }, style: {
                            padding: '10px 20px',
                            cursor: 'pointer',
                            backgroundColor: '#721c24',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px'
                        }, children: "Refresh Page" })] }));
        }
        return children;
    };
    return ErrorBoundary;
}(Component));
ErrorBoundary.defaultProps = {
    fallback: undefined,
    onError: undefined
};
export default ErrorBoundary;
